<template>
  <b-card>
    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$t('evento')"
            label-for="evento"
            :invalid-feedback="$t('campoObrigatorio')"
            :state="!$v.eventField.evento.id.$error"
          >
            <v-select
              v-model="eventField.evento"
              :options="eventos"
              label="nome"
              :reduce="(item) => item.id"
              :clearable="false"
              :state="!$v.eventField.evento.id.$error"
            >
              <template #option="{ nome, id }">
                {{ nome }} ({{ id }})
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group
            :label="$t('campo')"
            label-for="campo"
            :invalid-feedback="$t('campoObrigatorio')"
            :state="!$v.eventField.campo.id.$error"
          >
            <v-select
              v-model="eventField.campo"
              :options="campos"
              label="nome"
              :reduce="(item) => item.id"
              :clearable="false"
              :state="!$v.eventField.campo.id.$error"
            >
              <template #option="{ nome, id }">
                {{ nome }} ({{ id }})
              </template>
            </v-select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            :label="$t('valor')"
            label-for="valor"
            :invalid-feedback="$t('campoObrigatorio')"
            :state="!$v.eventField.valor.$error"
          >
            <b-form-input
              id="valor"
              v-model="eventField.valor"
              :state="!$v.eventField.valor.$error"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-checkbox v-model="eventField.ativo" switch>
            {{ $t("ativo") }}
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col cols="12" class="text-right">
          <b-button
            type="button"
            variant="light"
            class="mr-2"
            @click="cancelar"
          >
            {{ $t("cancelar") }}
          </b-button>
          <b-button type="submit" variant="primary">
            {{ $t("salvar") }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import { required } from "@validations";
import { mapState } from "vuex";

export default {
  name: "EventFieldForm",
  props: {
    initialData: {
      type: Object,
      default: () => ({
        id: null,
        evento: { id: null, nome: "" },
        campo: { id: null, nome: "" },
        valor: "",
        ativo: true,
      }),
    },
  },
  data() {
    return {
      eventField: { ...this.initialData },
      eventos: [],
      campos: [],
    };
  },
  validations: {
    eventField: {
      evento: {
        id: { required },
      },
      campo: {
        id: { required },
      },
      valor: { required },
    },
  },
  computed: {
    ...mapState("eventFieldSettingsModule", ["eventField"]),
  },
  created() {
    this.loadInitialData();
  },
  methods: {
    loadInitialData() {
      if (this.initialData.id) {
        this.eventField = { ...this.initialData };
      }
      this.searchEventos();
      this.searchCampos();
    },
    async searchEventos() {
      try {
        // TODO: Replace with actual API call to search eventos
        // const { data } = await this.$store.dispatch('eventFieldSettingsModule/loadEventos')
        // this.eventos = data.content || []
      } catch (error) {
        console.error("Error searching eventos:", error);
        this.$toast.error(this.$t("erroCarregarEventos"));
      }
    },
    async searchCampos() {
      try {
        // TODO: Replace with actual API call to search campos
        // const { data } = await this.$store.dispatch('eventFieldSettingsModule/loadCampos')
        // this.campos = data.content || []
      } catch (error) {
        console.error("Error searching campos:", error);
        this.$toast.error(this.$t("erroCarregarCampos"));
      }
    },
    handleSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit("submit", this.eventField);
      }
    },
    cancelar() {
      this.$emit("cancel");
    },
  },
};
</script>
